{
  "dailyChecklist": {
    "title": "Daily Missions",
    "subtitle": "Circle Community",
    "bonusTitle": "Daily Trifecta",
    "bonusDescription": "Complete all 3 for an extra bonus",
    "tasks": {
      "post": {
        "title": "Create a post",
        "description": "Publish a post in the community"
      },
      "comment": {
        "title": "Leave a comment",
        "description": "Comment on a community post"
      },
      "like": {
        "title": "Like a post",
        "description": "Like a post or comment in the community"
      }
    }
  },
  "toasts": {
    "xpEarned": "+{{xp}} XP earned!",
    "xpEarnedDescription": "Keep it up to level up!",
    "streakMilestone_one": "🔥 {{count}} day in a row!",
    "streakMilestone_zero": "🔥 {{count}} days in a row!",
    "streakMilestone_other": "🔥 {{count}} days in a row!",
    "streakMilestoneDescription": "Your dedication is inspiring!",
    "streakUpdated": "Streak updated!",
    "consecutiveDays_one": "{{count}} day in a row",
    "consecutiveDays_zero": "{{count}} days in a row",
    "consecutiveDays_other": "{{count}} days in a row"
  }
}
